import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './styles/design-tokens.css';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/app-theme.css';
import './styles/inspection-forms.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { setupClientErrorReporting } from './utils/clientErrorReporting';

setupClientErrorReporting();

const apiBase = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
if (apiBase) {
  axios.defaults.baseURL = apiBase;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
